// Generate JSON-LD for a blog post

import Script from 'next/script';
import type { Thing, WithContext } from 'schema-dts';
export type StructuredDataMarkupProps = {
  type?: 'BlogPosting' | 'Article';
  title: string;
  images: string[];
  datePublished?: string;
  dateModified?: string;
  authors?: {
    type: 'Person' | 'Organization';
    name: string;
    jobTitle?: string;
    url?: string;
  }[];
  breadcrumb?: {
    name: string;
    item: string;
  }[];
};
export function StructuredDataMarkup({
  type = 'BlogPosting',
  title,
  images,
  dateModified,
  datePublished,
  authors = [],
  breadcrumb = []
}: StructuredDataMarkupProps) {
  const jsonLd: WithContext<Thing>[] = [{
    '@context': 'https://schema.org',
    '@type': type,
    headline: title,
    image: images,
    dateModified,
    datePublished,
    author: authors.map(author => ({
      '@type': author.type,
      ...author
    }))
  }];
  if (breadcrumb.length > 0) {
    jsonLd.push({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumb.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: item.name,
        item: item.item
      }))
    });
  }
  return <Script id={`json-ld-blog-post-${title.toLowerCase().replace(/\s|'|’|\?|!/g, '-')}`} type="application/ld+json" dangerouslySetInnerHTML={{
    __html: JSON.stringify(jsonLd)
  }} data-sentry-element="Script" data-sentry-component="StructuredDataMarkup" data-sentry-source-file="structured-data-markup.tsx" />;
}